<template>
    <div>
        <div class="container">
            <div v-if="LoginMsg" class="mb-5 pb-4 d-sm-none d-md-block d-lg-block d-xl-block">
                <Message :notification="notification" />
            </div>
            <div v-if="LoginErrorMsg" class="mb-5 pb-4 d-none d-sm-none d-md-none d-lg-block d-xl-block">
                <ErrorMessage :errorNotification="errorNotification" />
            </div>
            <h1 class="title pb-3 mb-3 mt-3 mt-lg-0 mt-xl-0">
                Sign in to Harrods Rewards
                <span v-if="isMyBeauty"> and MyBeauty</span>
            </h1>
            <div id="divContainer"></div>
        </div>
    </div>
</template>

<script setup>
    import { ref, onMounted, inject, computed } from 'vue'
    import { useRoute } from 'vue-router'
    import { useStore } from 'vuex'
    import Message from '@/components/Message.vue'
    import ErrorMessage from '@/components/ErrorMessage.vue'
    import gigyaWebSDK from '@/gigyaWebSDK'

    const route = useRoute()
    const store = useStore()
    const isMyBeauty = inject('isMyBeauty', computed(() =>
        route.params.isMyBeauty === 'mybeauty' ||
        route.query.isMyBeauty === 'true' ||
        route.query.isMyBeauty === true
    ))

    const notification = ref('To download your digital Rewards card, we recommend signing in on a mobile device.')
    const errorNotification = ref('')
    const LoginMsg = ref(true)
    const LoginErrorMsg = ref(false)

    function displayLoginErrorMsg(errorMsg) {
        LoginMsg.value = false
        LoginErrorMsg.value = true
        errorNotification.value = errorMsg
    }

    // Created hook logic
    if (typeof window !== 'undefined') {
        const gigyaCache = sessionStorage.getItem("gigyaCache")
        if (gigyaCache) {
            const gigyaCacheObj = JSON.parse(gigyaCache)
            const gigyaContext = Object.keys(gigyaCacheObj).filter(k => k.startsWith('gig_oidcContext'))
            if (!gigyaContext || gigyaContext.length === 0) {
                store.dispatch("signin")
            }
        } else {
            store.dispatch("signin")
        }
    }

    onMounted(() => {
        gigyaWebSDK.accounts.showScreenSet({
            screenSet: "IdpLogon",
            containerID: "divContainer"
        })

        function redirectToProxy() {
            let url = gigyaWebSDK.utils.URL.addParamsToURL("proxy", {
                mode: "afterLogin",
            })
            window.location.assign(url)
        }

        gigyaWebSDK.socialize.addEventHandlers({
            onLogin: function () {
                redirectToProxy()
            },
            onError: (error) => {
                errorNotification.value = error
            }
        })
    })
</script>

<style lang="scss" scoped>
    .title {
        @media screen and (max-width: 767px) and (min-width: 0px) {
            font-size: 24px;
        }

        @media screen and (max-width: 991px) and (min-width: 768px) {
            font-size: 26px;
        }

        @media screen and (min-width: 992px) {
            font-size: 30px;
        }
    }
</style>
